<template>

    <trax-ui-ajax-form-hub id="trax-account-role-edit" :endpoint="endpoint" 
         :resource-id="roleid" :props="props" :bus="bus">
    </trax-ui-ajax-form-hub>

</template>

<script>
    export default {
    
        props: ['roleid'],
        
        data: function() {
            return {
                endpoint: app_url+"trax/api/front/roles",
                props: {
                    name: { source:'name' },
                    description: { source:'description' },
                    permissions: { source:'permissions' }
                },
                bus: this.$bus
            }
        }
    }
</script>
